import React from 'react';
import Icon from '../../../components/AppIcon';

const UpcomingDeadlineCard = ({ deadline }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-IN', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const getDaysRemaining = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = date - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const getUrgencyColor = (days) => {
    if (days <= 2) return 'text-error';
    if (days <= 5) return 'text-warning';
    return 'text-success';
  };

  const daysRemaining = getDaysRemaining(deadline?.date);

  return (
    <div className="bg-card rounded-lg p-4 border border-border hover:shadow-warm-sm transition-smooth">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Clock" size={20} color="var(--color-accent)" />
        </div>

        <div className="flex-1 min-w-0">
          <h5 className="text-sm font-medium text-card-foreground mb-1 line-clamp-2">
            {deadline?.title}
          </h5>
          <p className="text-xs text-muted-foreground mb-2 line-clamp-1">
            {deadline?.company}
          </p>

          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">
              {formatDate(deadline?.date)}
            </span>
            <span className={`text-xs font-medium ${getUrgencyColor(daysRemaining)}`}>
              {daysRemaining > 0 ? `${daysRemaining} days left` : 'Today'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcomingDeadlineCard;